import { StringKey } from '../../../../../lang/index';

export enum Column {
  ACTIONS = 'actions',
  CATEGORY = 'category',
  DOCUMENT_NAME = 'document-name',
  EXPIRY = 'expiry',
  LAST_SENT = 'last-sent',
  SIGNATORIES = 'signatories',
  STATUS = 'status',
}

export const columnTitleMap: Record<Column, StringKey> = {
  [Column.DOCUMENT_NAME]: 'DOCUMENT_NAME',
  [Column.CATEGORY]: 'CATEGORY',
  [Column.STATUS]: 'STATUS',
  [Column.SIGNATORIES]: 'SIGNATORIES',
  [Column.LAST_SENT]: 'SORT_LAST_SENT',
  [Column.EXPIRY]: 'SORT_EXPIRY',
  [Column.ACTIONS]: 'EMPTY',
};

export const columnOrderMap = Object.keys(columnTitleMap);
